module.exports = __webpack_public_path__ + "static/img/minimal_packaging_new.e0bed76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/minimal_packaging_new.png
// module id = WFVK
// module chunks = 1